
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "@/components/Header";
import { Layout } from "@/components/Layout";
import { useLogic } from "./useLogic";
import { DynamicForm } from "../trade/components/DynamicForm";
// import { Description } from "./Description";
import styles from './index.module.scss';
import { useMemo } from "react";
import { Button } from "antd-mobile";
import { DynamicFormItemProps } from "../trade/components/DynamicForm/DynamicForm";

export const PageMerchantBalanceTransout = () => {
  const logic = useLogic();


  const formFooter = useMemo(() => {
    return <div className={styles.footer}>
      <Button className={"common-submit-button"} onClick={() => {logic.onSubmit()}}>
        {'确定转出'}
      </Button>
    </div>
  }, [logic.onSubmit])
   const formItems: DynamicFormItemProps[] = useMemo(() => {
    return [
      {fieldLabel: '商家余额', fieldName: 'balance', fieldType: 'BalanceVB', readOnly: true,},
      {fieldLabel: '转出至', fieldName: 'mainNet', fieldType: '1', readOnly: true},
      {fieldLabel: '转出前VipPay钱包余额', fieldName: 'before_balance', fieldType: 'BalanceVB', readOnly: true},
      {fieldLabel: '转出金额', fieldName: 'amount', fieldType: '2', extra: <Button size="small" 
        className={styles.allBtn}
        onClick={logic.addAll}
      >全部</Button>},
      {fieldLabel: '转出后VipPay钱包余额', fieldName: 'after_balance', fieldType: 'BalanceVB', readOnly: true},
    ]
   }, [logic.addAll])
  

  return (
    <Layout
      scrollable
      backgroundImage={false}
      header={
        <Header
          title="商家余额转出"
          leftActions={<HeaderActionBack />}
          rightActions={<HeaderActionCustomerService />}
        />
      }
    >
      <div className={styles.main}>
        <div className={styles.form}>
          <DynamicForm
            items={formItems}
            onRef={logic.onFormRef}
            onValuesChange={logic.onValuesChange}
          />
        </div>
      </div>
      
      {/* <Description /> */}
      {formFooter}
    </Layout>
  );
};
